<template>
  <div class="footer-container">
    <div class="ool-container">
      <div class="textbox-container">@2026 Powered by</div>
      <img src="../../assets/logos/ool-logo.png" alt="ool-logo" width="75em">
    </div>
    <div class="customer-container">
      <div class="textbox-container">v{{ getAppVersion }}</div>
      <!-- <img src="../../assets/logos/guimaraes-logo.png" alt="client-logo" height="34px" width="104px"> -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FooterBar',
  computed: {
    getAppVersion(): string {
      return process.env.VUE_APP_VERSION || 'N/A'
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../styles/base.scss";
@import "../../styles/colors.scss";

.textbox-container {
  padding-right: 0.8em;
  font-size: 0.8rem;
  color: $black;
}

.footer-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 0.8em 1.6em;
  align-items: center;
  height: 50px;

  box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.07), 0 12px 28px 0 rgba(0, 0, 0, 0.76);

  .ool-container {
    justify-self: start;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
  }

  .customer-container {
    justify-self: end;
    display: flex;
    align-items: center;

    img {
      filter: invert(100%);
    }
  }
}

@media (max-width: 960px) {
  .footer-container {
    display: none;
  }
}
</style>
